import {useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/lootbox/state/prize';
import {redeemPrize, sellPrize} from '../../../../reducers/lootbox/actions';
import Diamond from '../diamond';
import BlueButton from '../../../components/blue-button';
import GrayButton from '../../../components/gray-button';
import ModalsLib from '../../../../lib/modals';

export default () => {
    const {box, buttons} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <>
            <div className="prize">
                <div className={`item ${box.prize.rarity}`}>
                    <div className="image">
                        <div className="blur"></div>
                        <img src={`${window.location.origin}/source/system/lootbox/drops/${box.prize.type}_${box.prize.rarity}.png`} alt="" />
                    </div>
                    <div className="item_info">
                        <div className="name">{box.prize.name}</div>
                        <div className="value">{box.prize.value}</div>
                    </div>
                </div>

                <div className="buttons">
                    {box.prize.type === 'diamonds' ? (
                        <></>
                    ) : (
                        <BlueButton disabled={buttons.sell} active={buttons.redeem} onClick={e => {
                            if(box.prize.type === 'freeplay') {
                                ModalsLib.open('changeGame', {
                                    redirect: false,
                                    handler: e => ModalsLib.open('freeplay_loot', {
                                        prize_id: box.prize_id,
                                        game: e,
                                        type: "freeplay",
                                        bonus: box.prize.price
                                    }) 
                                    // handler: e => ModalsLib.open('cashout', {game: e})
                                });
                            } else {
                                dispatch(redeemPrize(box.prize_id));
                            }
                        }}>Redeem {box.prize.value}</BlueButton>
                    )}
                    <GrayButton disabled={buttons.redeem} active={buttons.sell} onClick={e => dispatch(sellPrize(box.prize_id))}>
                        Sell for <span><Diamond />{box.prize.price}</span>
                    </GrayButton>
                </div>
            </div>
        </>
    )
}